import * as React from "react";
import { Box, Button, Icon, MenuItem, useDisclosure } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Form, Modal, TextInput } from "components";
import { useRename, VALIDATION_SCHEMA } from "./duck";

const Rename: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { onSubmit, initialName } = useRename(onClose);

  return (
    <>
      <MenuItem
        color="gray.900"
        fontSize="sm"
        py={2.5}
        lineHeight={5}
        icon={<Icon as={BiEditAlt} boxSize="16px" display="block" />}
        onClick={() => {
          onOpen();
        }}
      >
        Rename
      </MenuItem>
      <Modal title="Rename" isOpen={isOpen} onClose={onClose}>
        <Form
          onSubmit={onSubmit}
          validationSchema={VALIDATION_SCHEMA}
          defaultValues={{ name: initialName }}
        >
          <Box py={6}>
            <TextInput autoFocus label="Name" placeholder="Name" name="name" />
          </Box>
          <Form.Controls submitText="Save">
            <Button
              color="gray.700"
              variant="outline"
              colorScheme="gray"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Form.Controls>
        </Form>
      </Modal>
    </>
  );
};

export default Rename;
